import {match} from 'ts-pattern';

import {type InterestRecommendationSignal} from '@dms/api/interest-recommendations';
import i18n from '@dms/i18n';

export function getRecommendationSignalLabel(signal: InterestRecommendationSignal) {
  return match(signal.code)
    .with('customerAwaitingReply', () =>
      i18n.t('aiAssistant.interest.signals.customerAwaitingReply.title', {
        defaultValue: 'Customer awaiting reply',
      })
    )
    .with('noFirstResponse', () =>
      i18n.t('aiAssistant.interest.signals.noFirstResponse.title', {
        defaultValue: 'First response needed',
      })
    )
    .with('overdueTask', () =>
      i18n.t('feature.customerInsights.overdueTask', {
        defaultValue: 'Overdue task',
      })
    )
    .with('engagementDetected', () =>
      i18n.t('aiAssistant.interest.signals.engagementDetected.title', {
        defaultValue: 'Customer engagement detected',
      })
    )
    .with('missingNextStep', () =>
      i18n.t('entity.interestRecommendations.signals.missingNextStep', {
        defaultValue: 'Plan the next step',
      })
    )
    .with('goingCold', () =>
      i18n.t('aiAssistant.interest.signals.goingCold.title', {
        defaultValue: 'Interest going cold',
      })
    )
    .exhaustive();
}
